<div class="fnf-toast__icon rounded-circle" aria-hidden="true">
  <i class="bx" [ngClass]="iconClass"></i>
</div>

<div class="fnf-toast__body">
  <div class="fnf-toast__title" *ngIf="title">
    {{ title
    }}<span class="fnf-toast__count" *ngIf="duplicatesCount">({{ duplicatesCount + 1 }})</span>
  </div>

  <div
    class="fnf-toast__message"
    *ngIf="message && options.enableHtml"
    role="alert"
    [attr.aria-live]="ariaLive"
    [innerHTML]="message"
  ></div>

  <div
    class="fnf-toast__message"
    *ngIf="message && !options.enableHtml"
    role="alert"
    [attr.aria-live]="ariaLive"
  >
    {{ message }}
  </div>
</div>

<button
  type="button"
  class="fnf-toast__close"
  *ngIf="options.closeButton"
  (click)="close($event)"
  aria-label="Dismiss notification"
>
  <i class="bx bx-x-circle" aria-hidden="true"></i>
</button>

<div class="fnf-toast__progress" *ngIf="options.progressBar" [style.width.%]="width()"></div>
